<template>
  <div class="buttons__block w-full">
    <div class="btns flex flex-col gap-4 pb-4" :class="{'!justify-center !flex-row': isCallCenter}">
      <slot/>
    </div>
    <div class="powered">
      Powered by <img :src="logo" alt="fieldman">
    </div>
  </div>
</template>

<script setup lang="ts">
import logo from '@/assets/img/logo.svg';
const props = defineProps({
  isCallCenter: {type: Boolean, default: false},
})
</script>


<style lang="scss">
.buttons__block {
  padding: 16px 16px ;
  box-shadow: 0px -1px 1px rgba(0, 0, 0, 0.06);
  position: sticky;
  bottom: 0;
  background-color: #fff;
  z-index: 100;

  .powered {
    margin-top: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    font-weight: 600;
    font-size: 12px;
    line-height: 117%;
    letter-spacing: -0.01em;
    color: #656E7D;


  }
}

</style>